import axios from './index';

/**
 * APIs
 */
export function login(data: any) {
    return axios('/v1/login', {
        data,
        method: 'post',
    });
}
